import React from "react";

import { mdiInformation } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import "../../css/admin/utils/info-panel.scss";

import type { AppState } from "../../reducers";

interface InfoPanelProps {
  links: {
    en: string;
    fr: string;
  };
}

export default function InfoPanel({ links }: InfoPanelProps) {
  const { t } = useTranslation("editor-utils");
  const lang = useSelector((state: AppState) => state.variableReducer.lang);

  const link = links[lang] ? links[lang] : links.fr;

  return (
    <div className="editor-info-panel">
      <a href={link} rel="noopener noreferrer" target="_blank">
        <Icon path={mdiInformation} size={0.9} />
        <span>{t("learn_more")}</span>
      </a>
    </div>
  );
}
